//main
import ContentFormatXX from '../content/webc/content-format-xx';

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import TokensViewModule from '../content/tokens/tokens-view';

import { UserForm } from "../services/srvc-utilities";

export default function TokensView() {

  return (
  <>
    <ContentFormatXX 
      head='View Token Details'
      link={`/${UserForm()}/tokens`}
      form= 'small'
      data= {
        <>
          <WebbDividerSmall />
          <TokensViewModule />


        </>
      } 
    />
  </>
  )
}